import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { store } from './store/store'
import { auth } from './firebase/firebaseInit'
import VueSocialSharing from 'vue-social-sharing'
import { i18n } from "./i18n";
import { Trans } from './plugins/Translation'
import VueMeta from 'vue-meta'

import browserDetect from "vue-browser-detect-plugin";
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)

Vue.config.productionTip = false

let app

auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }
})

Vue.use(browserDetect);
Vue.use(VueSocialSharing);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

